<ng-container *ngIf="serverError">
  <div class="modal-header">
    <h4 class="modal-title">Server Error: {{ serverError }}</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
</ng-container>

<ng-container *ngIf="!serverError">

  <div class="modal-header">
    <h4 class="modal-title">Add Customer to Association</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div class="form-group">
      <label for="searchAssociationsInput">Search Associations</label>
      <input type="text" class="form-control" id="searchAssociationsInput"
             name="searchAssociationsInput"
             ngbAutofocus
             [(ngModel)]="associationFilters.search"
             (ngModelChange)="handleAssociationFilterChange()">
      <!-- We intentionally include the customer_id error, as that is the field used to communicate a duplicate member error. -->
      <div class="form-text text-danger">{{ errors.customer_id }}</div>
      <div class="form-text text-danger">{{ errors.association_id }}</div>
    </div>

    <!-- Add a fixed-height div to prevent the modal from shifting as results are loaded -->
    <div class="mt-3 mb-3" style="height: 231px;overflow-y: auto">

      <table class="table table-bordered table-hover"
             *ngIf="(associationFilters.search !== '') && (selectedAssociation === null)">
        <tbody *ngIf="!resultsPresent()">
          <tr>
            <td colspan="99">
              {{ loadingAssociations ? 'Loading...' : 'No results' }}
            </td>
          </tr>
        </tbody>
        <tbody *ngIf="resultsPresent()">
          <tr style="cursor:pointer"
              *ngFor="let association of associationList.results"
              (click)="selectAssociation(association)">
            <td>
              {{ association.name }}
            </td>
          </tr>
        </tbody>
      </table>

      <div class="alert alert-info" role="alert"
           *ngIf="(selectedAssociation !== null) && selectedAssociation.verification_requirements">
        {{ selectedAssociation.verification_requirements }}
      </div>

    </div>

    <div class="alert alert-danger" role="alert" *ngIf="errors.non_field_errors">
      {{ errors.non_field_errors }}
    </div>
    <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
      {{ errorMessage }}
    </div>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary"
            (click)="activeModal.close()">
      Cancel
    </button>
    <button type="button" class="btn btn-primary"
            (click)="handleSave()"
            [disabled]="!validInputSelected() || loadingSubmit"
            [class.disabled]="!validInputSelected() || loadingSubmit">
      {{ loadingSubmit ? 'Loading...' : 'Save' }}
    </button>
  </div>

</ng-container>
